import { createAction, props } from "@ngrx/store";
import { FirstParties } from "../models/FirstParties";
import { ServiceError } from "../../create-request/models/shared/ServiceError";

export const getModifiedFirstParties = createAction(
  `[Modified First Parties] Get modified first parties list`,
  props<{subaccount: string, transactionType: string}>()
);

export const getModifiedFirstPartiesSuccess = createAction(
  `[Modified First Parties] Successfully retrieved modified first parties list`,
  props<{response: FirstParties}>()
);

export const getModifiedFirstPartiesFailure = createAction(
  `[Modified First Parties] Failed retrieval of modified first parties list`,
  props<ServiceError>()
);